import {
  AZURE_RADIANCE_COLOR,
  BLACK_COLOR,
  BLACK_COLOR_04_OPACITY,
  BLACK_COLOR_20_OPACITY,
  BLACK_COLOR_25_OPACITY,
  BLACK_COLOR_40_OPACITY,
  BLACK_COLOR_88_OPACITY,
  BLUE_STROKE_BORDER,
  BRAND_BLUE,
  BRIGHT_BLUE_COLOR,
  BRIGHT_LIGHT_BLUE_COLOR,
  BRIGHT_RED_COLOR,
  BRIGHT_WARNING_COLOR,
  CHARCOAL_NAVY_COLOR,
  CHARCOAL_NAVY_COLOR_80_OPACITY,
  COLOR_SELECT_OPEN_LIGHT,
  COMET_COLOR,
  DARK_MODE,
  DARK_WARNING_COLOR,
  DIM_LIGHT_BLUE_COLOR,
  DUST_RED_COLOR,
  ERROR_COLOR,
  GREEN_SUCCESS_COLOR,
  GREEN_SUCCESS_ICON_COLOR,
  GUNMETAL_COLOR,
  ICE_BLUE_COLOR,
  IMG_BG_DARK,
  IMG_BG_LIGHT,
  LIGHT_BLUE,
  LIGHT_GRAY_COLOR,
  LIGHTER_GRAY_COLOR,
  LIGHTEST_GRAY_COLOR,
  LIGHTEST_GRAY_COLOR_80_OPACITY,
  OFF_GREY_COLOR,
  RUST_BLUE_COLOR,
  SEARCH_HIGHLIGHT_DARK,
  SEARCH_HIGHLIGHT_LIGHT,
  TABLE_ROW_HOVER_DARK,
  TABLE_ROW_HOVER_LIGHT,
  TRANSPARENT,
  WHITE_COLOR,
  WHITE_COLOR_08_OPACITY,
  WHITE_COLOR_20_OPACITY,
  WHITE_COLOR_25_OPACITY,
  WHITE_COLOR_40_OPACITY,
} from './constants'

export const customThemeGenerator = (theme) => {
  return {
    '--color-loading-overlay':
      theme == DARK_MODE
        ? CHARCOAL_NAVY_COLOR_80_OPACITY
        : LIGHTEST_GRAY_COLOR_80_OPACITY,
    '--color-loading-text':
      theme == DARK_MODE ? WHITE_COLOR : AZURE_RADIANCE_COLOR,

    '--color-border-custom': theme == DARK_MODE ? COMET_COLOR : OFF_GREY_COLOR,
    '--color-border-selected':
      theme == DARK_MODE ? BLUE_STROKE_BORDER : TRANSPARENT,
    '--color-text-alternate': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
    '--color-text-inverse': theme == DARK_MODE ? BLACK_COLOR : WHITE_COLOR,

    '--color-select-open-border':
      theme == DARK_MODE ? WHITE_COLOR : COLOR_SELECT_OPEN_LIGHT,
    '--color-select-dd-item-option-hover':
      theme == DARK_MODE ? LIGHT_BLUE : BLACK_COLOR_04_OPACITY,

    '--color-btn-focus-outline':
      theme == DARK_MODE ? BLUE_STROKE_BORDER : BRIGHT_LIGHT_BLUE_COLOR,
    '--color-input-hover-border':
      theme == DARK_MODE ? LIGHT_GRAY_COLOR : BRIGHT_BLUE_COLOR,

    '--color-form-error-broder':
      theme == DARK_MODE ? DUST_RED_COLOR : BRIGHT_RED_COLOR,

    '--color-form-link-normal':
      theme == DARK_MODE ? DIM_LIGHT_BLUE_COLOR : BRIGHT_LIGHT_BLUE_COLOR,
    '--color-form-link-danger':
      theme == DARK_MODE ? DUST_RED_COLOR : ERROR_COLOR,
    '--color-form-link-disabled':
      theme == DARK_MODE ?  WHITE_COLOR_40_OPACITY : BLACK_COLOR_40_OPACITY,

    // Scroll Colors
    '--color-table-scroll-bg': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,
    '--color-table-scroll-thumb': theme == DARK_MODE ? WHITE_COLOR_25_OPACITY : BLACK_COLOR_25_OPACITY,
    
    '--color-scroll-thumb': theme == DARK_MODE ? WHITE_COLOR_20_OPACITY : BLACK_COLOR_20_OPACITY,
    '--color-scroll-thumb-hover': theme == DARK_MODE ? WHITE_COLOR_40_OPACITY : BLACK_COLOR_40_OPACITY,


    // Sidebar Menu
    '--color-collapsed-menu-item-selected':
      theme == DARK_MODE ? LIGHT_BLUE : ICE_BLUE_COLOR,

    // Table
    '--color-selected-item' : theme == DARK_MODE ? BLUE_STROKE_BORDER : ICE_BLUE_COLOR,
    '--color-expanded-row-cell': theme == DARK_MODE ? RUST_BLUE_COLOR : LIGHTEST_GRAY_COLOR,
    '--color-background-delete-item-hover': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : LIGHTER_GRAY_COLOR,
    '--color-table-row-bg-hover': theme == DARK_MODE ? TABLE_ROW_HOVER_DARK : TABLE_ROW_HOVER_LIGHT,

    // Search match highlight
    '--color-search-highlight': theme == DARK_MODE ? 'rgba(250, 219, 20, 0.35)' : 'rgba(250, 219, 20, 0.65)',
    '--color-search-highlight-text': theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,

    // Popover / Message
    '--color-popover-bg': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : WHITE_COLOR,

    // Importers Upload Status
    '--color-sucess-icon': theme == DARK_MODE ? GREEN_SUCCESS_ICON_COLOR : BRIGHT_LIGHT_BLUE_COLOR,
    '--color-success-text': theme == DARK_MODE ? GREEN_SUCCESS_COLOR : BLACK_COLOR_88_OPACITY,
    '--color-warning-icon': theme == DARK_MODE ? DARK_WARNING_COLOR : BRIGHT_WARNING_COLOR,
    '--color-warning-text': theme == DARK_MODE ? DARK_WARNING_COLOR : BLACK_COLOR_88_OPACITY,
    '--color-warning-text-2': theme == DARK_MODE ? DARK_WARNING_COLOR : DARK_WARNING_COLOR,

    '--color-active-primary': theme == DARK_MODE ? DIM_LIGHT_BLUE_COLOR : BRIGHT_BLUE_COLOR,

    '--color-list-header': theme == DARK_MODE ? CHARCOAL_NAVY_COLOR : OFF_GREY_COLOR,

    // Tracer Preview status colors
    '--color-success-icon': theme == DARK_MODE ? GREEN_SUCCESS_ICON_COLOR : GREEN_SUCCESS_ICON_COLOR,
    '--color-text-quaternary': theme == DARK_MODE ? WHITE_COLOR_40_OPACITY : '#8c8c8c',

    // Modal
    '--color-background': theme == DARK_MODE ? GUNMETAL_COLOR : WHITE_COLOR,

    // Image Preview Background (For transparent PNG)
    '--color-img-background': theme == DARK_MODE ? IMG_BG_DARK: IMG_BG_LIGHT,

    // Greyed out instruction
    '--color-instruction': theme == DARK_MODE ? WHITE_COLOR_40_OPACITY : BLACK_COLOR_40_OPACITY,
    '--color-form-active-bg-primary': theme == DARK_MODE ? WHITE_COLOR : BRAND_BLUE,

    // Inline Text with Delete icon Hover color
    '--color-bg-hover-text-with-delete': theme == DARK_MODE ? WHITE_COLOR_08_OPACITY : BLACK_COLOR_04_OPACITY,

    // Search highlight
    '--color-bg-search-highlight': theme == DARK_MODE ? SEARCH_HIGHLIGHT_DARK : SEARCH_HIGHLIGHT_LIGHT,
  }
}
